module.exports = __webpack_public_path__ + "static/media/ci.c8ff48ab.svg";